import { TextCol } from "../../records/models/columns/text-col";
import { Fieldwork } from "./models/fieldwork";

export const FIELDWORK_SALES_COLUMNS: TextCol<Fieldwork>[] =
  [
    new TextCol("brand", false, undefined, undefined, true),
    new TextCol("regionName", undefined, 'stellantisRegion'), //stellantis region
    new TextCol("market"),
    new TextCol("importerName"),
    new TextCol("zone"),
    new TextCol("area"),
    new TextCol("dealerGroupName"),
    new TextCol("dealerCode"),
    new TextCol("dealerName"),
    new TextCol("outletCode"),
    new TextCol("outletName", undefined, "fieldworkOutletName"),
    new TextCol("agentCode", undefined, "fwOicCode"),
    new TextCol("agentName", undefined, "fwAgentName"),
    new TextCol("advisorName"),
    new TextCol("vin", true),
    new TextCol("vehicle", undefined, "fwVehicle"),
    new TextCol("engine", undefined, "fwEngine"),
    new TextCol("modelName"),
    new TextCol("customerName", true),
    new TextCol("customerEmail"),
    new TextCol("emailDiscardReason"),
    new TextCol("customerPhone"),
    new TextCol("mobileDiscardReason"),
    new TextCol("eventDate"),
    new TextCol("importedDate"),
    new TextCol("dateCleaned", undefined, "fwDateCleaned"),
    new TextCol("dateCleanedStatus", undefined, undefined, undefined, true),
    new TextCol("rejectedReason"),
    new TextCol("discardType"),
    new TextCol("initialInvitationDate"), //planned first day
    new TextCol("firstReminderDate"),
    new TextCol("secondReminderDate"),
    new TextCol("invitationDeliveryStatus", undefined, undefined, undefined, true),
    new TextCol("emailDeliveryDate", undefined, "fwEmailDeliveryDate"),
    new TextCol("mobileDeliveryDate", undefined, "fwMobileDeliveryDate"),
    new TextCol("receivedSurveyConfirmation"),
    new TextCol("interviewStatus", undefined, "fieldworkInterviewStatus", undefined, true),
    new TextCol("expiredDate", undefined, "fieldworkExpiredDate"),
    new TextCol("interviewStartedDate", undefined, "interviewOpenedDate"),
    new TextCol("interviewDate", undefined, "interviewdate"),
    new TextCol("surveyId", true),
    new TextCol("feedbackType"),
    new TextCol("uploadId"),
    new TextCol("externalRecordID"),
    new TextCol("externalCustomerID"),
    new TextCol("externalSeID"),
    new TextCol("wipNumber"),
    new TextCol("orderCustomerTypeSource", undefined, undefined, undefined, true),
    new TextCol("orderCustomerType", undefined, "TCO/Typeutil", undefined, true),
    new TextCol("promotionCode", undefined, "Promo Code - CCB / NRM Subtypes", undefined, true),
    new TextCol("orderCustomerSubtype", undefined, "Customer Subtype", undefined, true)
  ]
